import React from 'react'
import classes from './Breadcrumbs.module.scss'
import { useLocation } from 'react-router-dom'
import { Link } from 'react-router-dom'
import Icon from '../Icon/Icon'

interface Props {
  selectMenuLabel: (reportName: string) => string
}

const Breadcrumbs = (props: Props): JSX.Element => {
  const location = useLocation()
  const { pathname } = location

  const isOnStartPage = pathname === '/'
  const menuLabel = isOnStartPage ? null : props.selectMenuLabel(pathname)

  const inheritedInlineStyles = {
    textDecoration: 'inherit',
    color: 'inherit',
    fontWeight: 'inherit',
    fontSize: 'inherit'
  }

  return (
    <div className={classes.root}>
      {/* todo: Kanske ha en till länk först som länkar till pantamera */}

      <Link to="/" className={classes.startLink} style={inheritedInlineStyles}>
        <Icon iconName="home" />
        Start
      </Link>

      {!isOnStartPage && (
        <>
          <span className={classes.separator}>{'›'}</span>

          <span style={inheritedInlineStyles}>{menuLabel}</span>
        </>
      )}
    </div>
  )
}

export default Breadcrumbs
